import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { AuthProvider } from "./lib/auth";
import { IntlProvider } from "./lib/i18n";

import "./styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <IntlProvider>
          <App />
        </IntlProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
